import { StatusPill } from '../../../models/shared/status-pill';
import {
  RemittanceStatusBorderColorEnum,
  RemittanceStatusPrimaryColorEnum,
  RemittanceStatusSecondaryColorEnum
} from '../../../models/enum/shared/remittance-status-colors.enum';

export const IN_USE_STATUS_PILL = new StatusPill(
  0,
  $localize`In Use`,
  RemittanceStatusPrimaryColorEnum.Approved,
  RemittanceStatusSecondaryColorEnum.Approved,
  RemittanceStatusPrimaryColorEnum.Approved,
  RemittanceStatusBorderColorEnum.Approved
);

export const SUBMITTED_STATUS_PILL = new StatusPill(
  0,
  $localize`Submitted`,
  RemittanceStatusPrimaryColorEnum.Submitted,
  RemittanceStatusSecondaryColorEnum.Submitted,
  RemittanceStatusPrimaryColorEnum.Submitted,
  RemittanceStatusBorderColorEnum.Submitted
);

export const IN_REVIEW_STATUS_PILL = new StatusPill(
  0,
  $localize`In Review`,
  RemittanceStatusPrimaryColorEnum.InReview,
  RemittanceStatusSecondaryColorEnum.InReview,
  RemittanceStatusPrimaryColorEnum.InReview,
  RemittanceStatusBorderColorEnum.InReview
);
